<template>
  <div class="section4">
    <div class="title">
      <span class="name">开累经营数据</span>
    </div>
    <div class="items">
      <div class="item">
        <span class="label">营收计划（元）</span>
        <div class="value">
          <span>{{ details.planRevenueAmount ?? '--' }}</span>
        </div>
      </div>
      <div class="item">
        <span class="label">实际成本（元）</span>
        <div class="value">
          <span>¥</span>
          <span>{{ details.actualCostAmount ?? '--' }}</span>
        </div>
        <div class="desc">
          <span>较计划</span>
          <span>{{ Math.abs(details.actualToPlanCostAmount) }}</span>
          <img v-if="details.actualToPlanCostAmount > 0" src="@/assets/img/operate/up.png" />
          <img v-if="details.actualToPlanCostAmount < 0" src="@/assets/img/operate/down.png" />
        </div>
      </div>
      <div class="item">
        <span class="label">实际利润（元）</span>
        <div class="value">
          <span>{{ details.actualProfitAmount ?? '--' }}</span>
        </div>
        <div class="desc">
          <span>较计划</span>
          <span>{{ Math.abs(details.actualToPlanProfitAmount) }}</span>
          <img v-if="details.actualToPlanProfitAmount > 0" src="@/assets/img/operate/up.png" />
          <img v-if="details.actualToPlanProfitAmount < 0" src="@/assets/img/operate/down.png" />
        </div>
      </div>
      <div class="item">
        <span class="label">实际利润率</span>
        <div class="value">
          <span>{{ details.actualProfitPer ?? '--' }}%</span>
        </div>
        <div class="desc">
          <span>较计划</span>
          <span>{{ Math.abs(details.actualToPlanProfitPer) }}%</span>
          <img v-if="details.actualToPlanProfitPer > 0" src="@/assets/img/operate/up.png" />
          <img v-if="details.actualToPlanProfitPer < 0" src="@/assets/img/operate/down.png" />
        </div>
      </div>
      <div class="item">
        <span class="label">待回款额（元）</span>
        <div class="value">
          <span>{{ details.waitBackAmount ?? '--' }}</span>
        </div>
        <div class="desc">
          <span>较计划</span>
          <span>{{ Math.abs(details.waitToPlanBackAmount) }}</span>
          <img v-if="details.waitToPlanBackAmount > 0" src="@/assets/img/operate/up.png" />
          <img v-if="details.waitToPlanBackAmount < 0" src="@/assets/img/operate/down.png" />
        </div>
      </div>
    </div>
    <div class="chart-content2">
      <div class="chart-item">
        <div class="chart-title">
          <span>实际成本与合同额占比</span>
        </div>
        <div class="chart-content" id="chart5"></div>
      </div>
      <div class="chart-item">
        <div class="chart-title">
          <span>实际与计划成本对比</span>
        </div>
        <div class="chart-content" id="chart6"></div>
      </div>
      <div class="chart-item">
        <div class="chart-title">
          <span>实际与计划回款对比</span>
        </div>
        <div class="chart-content" id="chart7"></div>
      </div>
    </div>
  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
export default {
  mixins: [chartMixin],
  name: 'Section4',
  data() {
    return {
      details: {
        planRevenueAmount: '', // 营收计划金额
        actualCostAmount: '', // 实际成本金额
        planCostAmount: '', // 计划成本金额
        actualToPlanCostAmount: '', // 实际较计划成本差值金额
        actualProfitAmount: '', // 实际利润金额
        planProfitAmount: '', // 计划利润金额
        actualToPlanProfitAmount: '', // 实际较计划利润差值金额
        actualProfitPer: '', // 实际利润率
        planProfitPer: '', // 计划利润率
        actualToPlanProfitPer: '', // 实际较计划利润率差值
        planYoyRevenueAmount: '', // 年营收计划同比差值金额【年经营数据】
        actualBackAmount: '', // 实际回款金额【年经营数据】
        planBackAmount: '', // 计划回款金额【年经营数据】
        actualToPlanBackAmount: '', // 实际较计划回款差值金额【年经营数据】
        waitBackAmount: '', // 待回款金额【开累经营数据】
        waitToPlanBackAmount: '', // 待回款较计划回款差值金额【开累经营数据】
        actualCostTypePerList: [], // 实际成本分类占比数组(顺序：人、机、材、间)
        actualCostTypeAmountList: [], // 实际成本分类金额数组(顺序：人、机、材、间)
        planCostTypeAmountList: [], // 计划成本分类金额数组(顺序：人、机、材、间)
        actualCostTypeContractPerList: [], // 实际成本分类在合同中占比数组【开累经营数据】(顺序：人、机、材、间)
        backYearList: [], // 回款年份列表【开累经营数据】
        actualBackAmountList: [], // 实际回款金额列表【开累经营数据】
        planBackAmountList: [] // 计划回款金额列表【开累经营数据】
      }
    }
  },
  computed: {
  },
  watch: {
  },
  created() {
    // do something
    this.$event.$on('projectSearchChange', this.loadData)
  },
  beforeDestroy() {
    this.$event.$off('projectSearchChange')
  },
  methods: {
    loadData(searchForm) {
      this.$axios.get(this.$apis.operate.selectAllYear, {
        projectId: searchForm.projectId
      }).then(res => {
        this.details = res
        this.$nextTick(() => {
          this.initChart1()
          this.initChart2()
          this.initChart3()
        })
      })
    },
    initChart1() {
      const chart = this.$getChartInstance('#chart5')
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            return `${params[0].marker} ${params[0].name} : ${params[0].value}%`
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          show: false,
        },
        yAxis: {
          type: 'category',
          data: ['人力成本', '机械成本', '材料成本', '间接费'].reverse(),
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: '占比',
            type: 'bar',
            showBackground: true,
            barWidth: 24,
            color: '#1AD1B0',
            data: this.details.actualCostTypeContractPerList.reverse()
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
    },
    initChart2() {
      const chart = this.$getChartInstance('#chart6')
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              // 显示系列名称、图例颜色和数据信息
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['人力成本', '机械成本', '材料成本', '间接费'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#346EB1',
            },
            data: this.details.planCostTypeAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#39E179' }, // 起始颜色
                { offset: 0, color: '#9DD6BD' } // 结束颜色
              ]),
            },
            data: this.details.actualCostTypeAmountList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
    },
    initChart3() {
      const chart = this.$getChartInstance('#chart7')
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              // 显示系列名称、图例颜色和数据信息
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          },
          data: this.details.backYearList
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [0, 50, 50, 0],
              color: '#346EB1',
            },
            data: this.details.planBackAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [0, 50, 50, 0],
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 1, color: '#39E179' }, // 起始颜色
                { offset: 0, color: '#9DD6BD' } // 结束颜色
              ]),
            },
            data: this.details.actualBackAmountList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
    }
  }
}
</script>

<style scoped lang="scss">
.section4 {
  padding: 20px;
  display: flex;
  flex-direction: column;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .items {
    display: flex;

    .item {
      flex: 1;
      width: 331px;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;

      &:nth-child(n + 2) {

        &::before {
          content: '';
          position: absolute;
          width: 1px;
          height: 81px;
          background-color: #E3E3E3;
          top: 0;
          left: 0;
        }
      }

      .label {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        text-align: left;
        font-style: normal;
      }

      .value {
        margin-top: 20px;

        span {
          &:first-child {
            font-size: 24px;
          }

          &:last-child {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 30px;
            color: #333333;
            line-height: 38px;
            text-align: left;
            font-style: normal;
            margin-top: 20px;
          }
        }
      }

      .desc {
        display: flex;
        align-items: center;
        margin-top: 20px;

        span {
          &:nth-child(1) {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          &:nth-child(2) {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #354052;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            margin-left: 10px;
          }
        }

        img {
          width: 15px;
          height: 18px;
          margin-left: 10px;
        }
      }
    }
  }

  .chart-content2 {
    flex: 1;
    display: flex;
    align-items: center;
    margin-top: 50px;

    .chart-item {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;

      &:nth-child(n + 2) {
        margin-left: 80px;
      }

      .chart-title {
        display: flex;
        align-items: center;
        margin-bottom: 40px;

        span {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 16px;
          color: #7F8FA4;
          line-height: 24px;
          text-align: left;
          font-style: normal;
        }
      }

      .chart-content {
        flex: 1;
      }
    }
  }
}
</style>
